import { Box } from '@mui/material';
import type React from 'react';
import { useTenderDetails } from '../../contexts/TenderDetailsContext';
import ReviewActionCard from './ActionCards/ReviewActionCard';
import ReviewDraftsSection from './ReviewDraftsSection';
import WorkflowStep from './WorkflowStep';

const ReviewDraftsStep: React.FC = () => {
  const {
    canManageTender,
    openStep,
    setOpenStep,
    tender,
    validTenderId,
    drafts,
    loadingStates,
    handleDeleteDraft,
    handleRegenerate,
    handleDownload,
    handleResetTender,
    isDraggingReview,
    handleDragEventsReview,
    handleDropReview,
    handleFileUpload,
    uploadValidationWarning,
    handleUpdateServiceStatus,
    handleNavigateToDownload,
  } = useTenderDetails();

  if (!canManageTender) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={14}
      expanded={openStep === 14}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 14 : null)}
      title="Final Draft Review"
      description="Upload your latest draft for a comprehensive AI review."
      isComplete={!!tender.reviewFileLink}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <ReviewDraftsSection
          tenderId={validTenderId}
          drafts={drafts}
          loadingStates={loadingStates}
          onDeleteDraft={handleDeleteDraft}
        />
        <ReviewActionCard
          tender={tender}
          loadingStates={loadingStates}
          onRegenerate={handleRegenerate}
          onDownload={handleDownload}
          onReset={() => handleResetTender('review')}
          isDragging={isDraggingReview}
          onDragEnter={handleDragEventsReview}
          onDragOver={handleDragEventsReview}
          onDragLeave={handleDragEventsReview}
          onDrop={handleDropReview}
          onFileUpload={(file) => handleFileUpload(file, 'review_draft', {})}
          uploadValidationWarning={uploadValidationWarning.review}
          draftsCount={drafts.length}
          onUpdateStatus={handleUpdateServiceStatus}
          onNavigateToDownload={handleNavigateToDownload}
        />
      </Box>
    </WorkflowStep>
  );
};

export default ReviewDraftsStep;
